/* eslint-disable react/prop-types */

import axios from "axios"

import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Table from "examples/Tables/Table";
import Icon from "@mui/material/Icon";
import Link from "@mui/material/Link";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import SoftBadge from "components/SoftBadge";
import SoftAvatar from "components/SoftAvatar";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PermissionNavbar from "examples/Navbars/PermissionNavbar";

import Header from "layouts/izinler/Header";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHouse, faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons'


function Tables() {






  const navigate = useNavigate();
  //const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const allString = "TÜMÜ";


  const changeYear = (amount) => {
    if (selectedYear !== allString) {
      setSelectedYear((prevYear) => prevYear + amount);
    }
  };

  const YearAllChange = () => {
    if (selectedYear === allString) {
      setSelectedYear(currentYear);
    }
    else {
      setSelectedYear(allString);
    }
  };


  const truncatedTextStyle = {
    width: '300px',
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: 1,
    height: '20px',
    WebkitBoxOrient: 'vertical'
  };

  const [data, setData] = useState([]);


  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        if (selectedYear === allString) {
          const response = await axios.get(`${window.BASE_URL}/saglikraporu?format=json`, { withCredentials: true });
          setData(response.data);
        }
        else {
          const response = await axios.get(`${window.BASE_URL}/saglikraporu-yil/${selectedYear}?format=json`, { withCredentials: true });
          setData(response.data);
        }
      } catch (error) {
        console.log(error);

      }
      finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [selectedYear]);


  let egitimRows = data.map(index => {
    return {
      "Adı": [
        <img key="" src="12" alt="Logo" />,
        <span key="task1" style={truncatedTextStyle}> {index.user.name + " " + index.user.surname}  </span>
      ],
      "Gün": <SoftBadge variant="gradient" badgeContent={index.gun_sayisi + " Gün"} color="info" size="xs" container />,

      "Tarih": <SoftTypography variant="caption" color="text" fontWeight="medium">{index.tarih} </SoftTypography>,

      "Düzenleme": <><SoftTypography component="a" href={`/form/duzenle/SaglikRaporu/${index.id}`} variant="caption" color="secondary" fontSize="medium" > <FontAwesomeIcon icon={faPenToSquare} /></SoftTypography>
        <SoftTypography component="a" href={`/form/sil/SaglikRaporu/${index.id}`} variant="gradient" color="text" fontSize="medium" style={{ marginLeft: "10px" }} > <FontAwesomeIcon icon={faTrash} /></SoftTypography>
      </>,

      "field_username": index.user.name + " " + index.user.surname,
      "field_gun": index.gun_sayisi,


    };
  });

  const projectsTableData = {
    columns: [
      { name: "Adı", align: "left", exportableField: "field_username", searchable: true, searchField: ["field_username"] },
      { name: "Gün", align: "center", exportableField: "field_gun", searchable: true, searchField: ["field_gun"] },
      { name: "Tarih", align: "center" },

      { name: "Düzenleme", align: "center" },

      //{ name: "Durum", align: "left" },

    ],

    rows: [
      ...egitimRows,

    ],
  };











  return (

    <Grid item xs={12} md={12} xl={12}>

      <SoftBox display="flex" justifyContent="flexStart" gap={2} alignItems="center" flexDirection="row-reverse" p={3} >
        <SoftButton variant="outlined" color="secondary" onClick={() => navigate('/form/olustur/SaglikRaporu')}>
          yeni rapor&nbsp;&nbsp;
          <Icon>create</Icon>
        </SoftButton>

        <SoftButton size="small" variant="." color="light" onClick={() => changeYear(-1)} disabled={isLoading}>
          <div style={{ color: "#8392ab", fontSize: "30px", height: "25px", marginTop: "-5px", width: "0px", marginLeft: "-40px" }}>
            <Icon>keyboard_arrow_right</Icon>
          </div>
        </SoftButton>

        <SoftButton variant="gradient" color="info" onClick={() => YearAllChange()} disabled={isLoading}>
          <a style={{ fontSize: "0.9rem" }}> {selectedYear} </a>
        </SoftButton>

        <SoftButton size="small" variant="." color="light" onClick={() => changeYear(1)} disabled={isLoading}>
          <div style={{ color: "#8392ab", fontSize: "30px", height: "25px", marginTop: "-5px", width: "0px", marginLeft: "-20px" }}>
            <Icon>keyboard_arrow_left</Icon>
          </div>
        </SoftButton>

      </SoftBox>

      <Card>
        <SoftBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
          <SoftTypography variant="h6">Raporlu İzinler Listesi</SoftTypography>
        </SoftBox>
        <SoftBox
          sx={{
            "& .MuiTableRow-root:not(:last-child)": {
              "& td": {
                borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                  `${borderWidth[1]} solid ${borderColor}`,
              },
            },
          }}
        >
          <Table columns={projectsTableData.columns} rows={projectsTableData.rows} isLoading={isLoading} />
        </SoftBox>
      </Card>

    </Grid>


  );

}

export default Tables;
